function getImageElement(parent) {
  return Array.from(parent.children).find(
    (el) => el.nodeName === 'IMG',
  )
}
function loadImage(el) {
  const imageElement = getImageElement(el)
  if (imageElement) {
    imageElement.addEventListener('load', () => {
      setTimeout(() => el.classList.add('loaded'), 100)
    })
    imageElement.addEventListener('error', () => {
      setTimeout(() => el.classList.add('error'), 100)
    })
    imageElement.src = imageElement.dataset.url
  }
}

function handleIntersect(el) {
  return (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadImage(el)
      }
    })
  }
}

function handleMutation(el) {
  return (entries) => {
    entries.forEach((entry) => {
      if (entry.attributeName === 'data-url') {
        if (getImageElement(el)) {
          getImageElement(el).src = ''
        }
        el.classList.remove('loaded')
        setTimeout(() => {
          loadImage(el)
        }, 0)
      }
    })
  }
}

function createObserver(el) {
  const options = {
    root: null,
    threshold: '0',
  }
  const intersecHandler = handleIntersect(el)
  const intersectionObserver = new IntersectionObserver(intersecHandler, options)
  intersectionObserver.observe(el)

  const imgElement = getImageElement(el)
  const mutationHandler = handleMutation(el)
  const mutationObserver = new MutationObserver(mutationHandler, options)
  mutationObserver.observe(imgElement, { attributes: true })
}

export default {
  inserted: (el) => {
    if (window.IntersectionObserver) {
      createObserver(el)
    } else {
      loadImage(el)
    }
  },
}
